const Car = () => (
  <svg
    fill="#ffffff"
    viewBox="0 0 32 32"
    height={50}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <title>car</title>{" "}
      <path d="M27 22h-23c-1.104 0-2-0.896-2-2v-5c0-1.104 0.896-2 2-2h1c0 0 1.479-4.5 1.916-6s0.896-2 2.001-2h13.166c1.104 0 1.438 0.312 2 2s1.917 6 1.917 6h1c1.104 0 2 0.896 2 2v5c0 1.104-0.896 2-2 2zM9 20h13v-1h-13v1zM22 13c0-1.104-0.896-2.125-2-2.125s-2 1.021-2 2.125c0 0.026 4 0.026 4 0zM9 18h13v-1h-13v1zM9 16h13v-1h-13v1zM4.062 17c0 1.104 0.896 2 2 2s2-0.896 2-2-0.896-2-2-2-2 0.896-2 2zM23.083 7c-0.25-0.688-0.447-1-1-1h-6.083v1h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.5v-1h-6.083c-0.553 0-0.751 0.125-1 1-0.251 0.875-1.917 6-1.917 6h11.46c0.023-1.364 1.13-2.643 2.495-2.643s2.472 1.278 2.496 2.643h2.549c0 0-1.667-5.312-1.917-6zM24.938 15.062c-1.104 0-2 0.896-2 2s0.896 2 2 2 2-0.896 2-2-0.896-2-2-2zM7 25.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-2.5h3v2.5zM27 25.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-2.5h3v2.5z"></path>{" "}
    </g>
  </svg>
);

export default Car;
